<template lang="pug">
span.d-inline-flex.align-center
  v-tooltip(content-class="faq-tooltip", bottom, open-on-hover, open-on-focus)
    template(v-slot:activator="{ on, attrs }")
      span.d-inline-flex.align-center(v-bind="attrs", v-on="on", tabindex="0", role="img", :aria-label="nomeStatus(status)")
        v-icon(small, :color="corStatus(status)", aria-hidden="true") mdi-circle
    span {{ nomeStatus(status) }}
</template>

<script>
import { nomeStatus, corStatus } from "@/utils/faqStatus";

export default {
  name: "FaqStatus",
  props: {
    status: { type: String, default: "" }
  },
  methods: { nomeStatus, corStatus }
};
</script>
